function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userList from '../user/list';
import { employeeAddRole, employeeUpdateRole } from '@/api/staff';
import { productLstApi } from '@/api/product';
import { validatePhone } from '@/utils/toolsValidate';
export default {
  components: {
    userList: userList
  },
  props: ['editData', 'isCreate'],
  data: function data() {
    return {
      selectedRow: null,
      userVisible: false,
      productVisible: false,
      productLoading: false,
      pageSelectedRows: [],
      productTableData: {
        list: [],
        total: 0
      },
      productSearch: {
        page: 1,
        limit: 10,
        keywords: '',
        type: 1
      },
      editPram: {
        avatar: null,
        name: null,
        uid: null,
        phone: null,
        status: false,
        role: [],
        id: null,
        nickname: null,
        userAvatar: null,
        verificationScopeType: 1,
        productIds: [],
        selectedProducts: []
      },
      rules: {
        avatar: [{
          required: true,
          message: '请设置头像',
          trigger: 'change'
        }],
        role: [{
          required: true,
          message: '请设置管理权限',
          trigger: 'change'
        }],
        uid: [{
          required: true,
          message: '请关联用户',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    hasVerificationRole: function hasVerificationRole() {
      return this.editPram.role.includes('5');
    }
  },
  watch: {
    hasVerificationRole: function hasVerificationRole(val) {
      if (!val) {
        this.editPram.verificationScopeType = 1;
        this.editPram.productIds = [];
        this.editPram.selectedProducts = [];
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;
      if (this.isCreate !== 1) return;
      Object.keys(this.editData || {}).forEach(function (key) {
        _this2.editPram[key] = _this2.editData[key];
      });
      this.editPram.role = Array.isArray(this.editPram.role) ? this.editPram.role : (this.editPram.role || '').split(',').filter(Boolean);
      this.editPram.verificationScopeType = this.editPram.verificationScopeType || 1;
      this.editPram.selectedProducts = Array.isArray(this.editPram.selectedProducts) ? this.editPram.selectedProducts : [];
      this.editPram.productIds = Array.isArray(this.editPram.productIds) ? this.editPram.productIds : this.editPram.selectedProducts.map(function (item) {
        return item.productId;
      });
    },
    getUser: function getUser() {
      this.editPram.userAvatar = this.selectedRow.avatar;
      this.editPram.uid = this.selectedRow.id;
      this.editPram.nickname = this.selectedRow.nickname;
      this.userVisible = false;
    },
    getRow: function getRow(row) {
      this.selectedRow = row;
      this.getUser();
    },
    handlerClose: function handlerClose() {
      this.$emit('hideEditDialog', 0);
    },
    handlerSubmit: function handlerSubmit(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (!valid) return;
        if (_this3.hasVerificationRole && _this3.editPram.verificationScopeType === 2 && !_this3.editPram.productIds.length) {
          return _this3.$message.warning('请选择可核销商品');
        }
        var pram = _objectSpread(_objectSpread({}, _this3.editPram), {}, {
          role: _this3.editPram.role.join(','),
          status: _this3.editPram.status ? 1 : 0,
          uid: +_this3.editPram.uid,
          productIds: _this3.hasVerificationRole && _this3.editPram.verificationScopeType === 2 ? _this3.editPram.productIds : [],
          verificationScopeType: _this3.hasVerificationRole ? _this3.editPram.verificationScopeType : 1
        });
        var request = _this3.isCreate === 0 ? employeeAddRole(pram) : employeeUpdateRole(pram);
        request.then(function () {
          _this3.$emit('hideEditDialog', 1, _this3.isCreate);
        });
      });
    },
    openProductDialog: function openProductDialog() {
      this.productVisible = true;
      this.getProductList();
    },
    getProductList: function getProductList() {
      var _this4 = this;
      this.productLoading = true;
      productLstApi(this.productSearch).then(function (res) {
        _this4.productTableData.list = res.list || [];
        _this4.productTableData.total = res.total || 0;
        _this4.$nextTick(function () {
          _this4.restoreProductSelection();
        });
      }).finally(function () {
        _this4.productLoading = false;
      });
    },
    restoreProductSelection: function restoreProductSelection() {
      var _this5 = this;
      if (!this.$refs.productTable) return;
      this.$refs.productTable.clearSelection();
      var selectedIds = new Set(this.editPram.productIds);
      this.productTableData.list.forEach(function (row) {
        if (selectedIds.has(row.id)) {
          _this5.$refs.productTable.toggleRowSelection(row, true);
        }
      });
    },
    handleProductSelectionChange: function handleProductSelectionChange(rows) {
      this.pageSelectedRows = rows || [];
    },
    confirmSelectedProducts: function confirmSelectedProducts() {
      var selectedMap = {};
      this.editPram.selectedProducts.forEach(function (item) {
        selectedMap[item.productId] = item;
      });
      this.pageSelectedRows.forEach(function (row) {
        selectedMap[row.id] = {
          productId: row.id,
          name: row.name,
          image: row.image,
          price: row.price,
          stock: row.stock
        };
      });
      this.editPram.selectedProducts = Object.values(selectedMap);
      this.editPram.productIds = this.editPram.selectedProducts.map(function (item) {
        return item.productId;
      });
      this.productVisible = false;
    },
    removeSelectedProduct: function removeSelectedProduct(productId) {
      this.editPram.selectedProducts = this.editPram.selectedProducts.filter(function (item) {
        return item.productId !== productId;
      });
      this.editPram.productIds = this.editPram.selectedProducts.map(function (item) {
        return item.productId;
      });
    },
    handleProductSizeChange: function handleProductSizeChange(val) {
      this.productSearch.limit = val;
      this.getProductList();
    },
    handleProductCurrentChange: function handleProductCurrentChange(val) {
      this.productSearch.page = val;
      this.getProductList();
    },
    modalPicTap: function modalPicTap(tit, num) {
      var _this = this;
      var attr = [];
      this.$modalUpload(function (img) {
        if (!img) return;
        if (tit === '1' && !num) {
          _this.editPram.avatar = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          img.map(function (item) {
            attr.push(item.attachment_src);
            _this.formValidate.slider_image.push(item);
          });
        }
      }, tit, 'store');
    }
  }
};